export const alerts = [
  {
    id: 1,
    type: 'Recall',
    severity: 'High',
    title: 'URGENT: Ambrosia Brands LLC Recalls Rosabella Moringa Capsules',
    date: 'Feb 13, 2026',
    brand: 'Ambrosia Brands LLC / Rosabella',
    summary: 'Recall issued due to possible health risks associated with Salmonella contamination. Consumers are advised to stop use immediately.',
    status: 'Active',
    url: 'https://www.fda.gov/safety/recalls-market-withdrawals-safety-alerts/ambrosia-brands-llc-recalls-rosabella-moringa-capsules-because-possible-health-risk'
  },
  {
    id: 2,
    type: 'Outbreak',
    severity: 'High',
    title: 'CDC Investigation: Salmonella Linked to Moringa Capsules',
    date: 'Feb 26, 2026',
    brand: 'Multiple Manufacturers',
    summary: 'CDC is investigating a multistate outbreak of Salmonella infections linked to moringa powder and capsules.',
    status: 'Ongoing Investigation',
    url: 'https://www.cdc.gov/salmonella/outbreaks/moringacapsules-02-26/index.html'
  },
  {
    id: 3,
    type: 'Warning',
    severity: 'Medium',
    title: 'XDR Salmonella Strain Linked to Dietary Supplements',
    date: 'Feb 2026',
    brand: 'General Advisory',
    summary: 'Extensively drug-resistant (XDR) Salmonella strain identified in recent outbreak involves moringa products.',
    status: 'Alert',
    url: 'https://www.food-safety.com/articles/11142-salmonella-outbreak-linked-to-dietary-supplement-involves-extensively-drug-resistant-strain'
  }
];

export const articles = [
  {
    id: 1,
    category: 'News',
    title: 'Miracle Supplement Recalled Nationwide Over Death & Diarrhea Risks',
    author: 'Newsweek Health',
    date: 'Feb 2026',
    image: 'https://images.unsplash.com/photo-1512069772995-ec65ed45afd6?auto=format&fit=crop&q=80&w=800',
    excerpt: 'A nationwide recall has been issued for a popular health supplement after reports of severe illness and potential fatalities.',
    url: 'https://www.newsweek.com/miracle-supplement-recalled-nationwide-over-death-diarrhea-risks-11524795'
  },
  {
    id: 2,
    category: 'Investigation',
    title: 'New Outbreak Traced to Moringa Capsules Under Investigation',
    author: 'Food Safety News',
    date: 'Feb 2026',
    image: 'https://images.unsplash.com/photo-1576086213369-97a306d36557?auto=format&fit=crop&q=80&w=800',
    excerpt: 'Detailed tracking of the current salmonella outbreak linked specifically to moringa supplement consumption across several states.',
    url: 'https://www.foodsafetynews.com/2026/02/new-outbreak-traced-to-moringa-capsules-under-investigation/'
  },
  {
    id: 3,
    category: 'Legal',
    title: 'Rosabella Moringa Capsule Lawsuit Information',
    author: 'Schmidt Law Firm',
    date: 'Feb 2026',
    image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&q=80&w=800',
    excerpt: 'Legal resources and information for consumers affected by the Rosabella Moringa capsule recall and subsequent illnesses.',
    url: 'https://www.schmidtlaw.com/rosabella-moringa-capsule-lawsuit/'
  },
  {
    id: 4,
    category: 'State Health Alert',
    title: 'IDPH Warning: Multistate Salmonella Outbreak Linked to Moringa',
    author: 'Illinois Dept of Public Health',
    date: 'Feb 13, 2026',
    image: 'https://images.unsplash.com/photo-1584036561566-baf8f5f1b144?auto=format&fit=crop&q=80&w=800',
    excerpt: 'Illinois health officials advise consumers to check their supplements following a nationwide outbreak of Salmonella.',
    url: 'https://dph.illinois.gov/content/soi/idph/en/resource-center/news/2026/february/release-20260213.html'
  },
  {
    id: 5,
    category: 'State Health Alert',
    title: 'WA DOH: Extensively Drug-Resistant Salmonella Outbreak',
    author: 'Washington Dept of Health',
    date: 'Feb 2026',
    image: 'https://images.unsplash.com/photo-1532938911079-1b06ac7ceec7?auto=format&fit=crop&q=80&w=800',
    excerpt: 'Official health advisory from Washington State regarding drug-resistant salmonella linked to moringa powder.',
    url: 'https://doh.wa.gov/you-and-your-family/illness-and-disease-z/foodborne-illness/outbreaks/2026-extensively-drug-resistant-salmonella-multistate-outbreak-linked-moringa-powder-capsules'
  },
  {
    id: 6,
    category: 'Investigation Detail',
    title: 'Detailed CDC Outbreak Investigation Timeline',
    author: 'CDC Gov',
    date: 'Feb 26, 2026',
    image: 'https://images.unsplash.com/photo-1583947215259-38e31be8751f?auto=format&fit=crop&q=80&w=800',
    excerpt: 'Technical data and timeline of the Salmonella investigation including laboratory findings and case counts.',
    url: 'https://www.cdc.gov/salmonella/outbreaks/moringacapsules-02-26/investigation.html'
  }
];

export const products = [
  {
    id: 1,
    name: 'Rosabella Moringa Capsules',
    brand: 'Ambrosia Brands LLC',
    rating: 'F',
    status: 'RECALLED',
    lastTested: 'Feb 2026',
    image: 'https://images.unsplash.com/photo-1471864190281-a93a3070b6de?auto=format&fit=crop&q=80&w=400'
  },
  {
    id: 2,
    name: 'Moringa Leaf Powder',
    brand: 'General Distribution',
    rating: 'C',
    status: 'Under Investigation',
    lastTested: 'Jan 2026',
    image: 'https://images.unsplash.com/photo-1615485290386-cca6361638e2?auto=format&fit=crop&q=80&w=400'
  }
];